import React from "react";
import { NUMBER } from "../../constants/app-constants";

export const getBoldText = (text = "") => {
    return text.split("**").map((el, index) =>
        index % NUMBER.TWO === 0 ? el : <span key={index}>{el}</span>
    );
};
